import { render } from "./StrongSidesComparisonBlock.vue?vue&type=template&id=fa79c3d2&scoped=true"
import script from "./StrongSidesComparisonBlock.vue?vue&type=script&lang=js"
export * from "./StrongSidesComparisonBlock.vue?vue&type=script&lang=js"

import "./StrongSidesComparisonBlock.vue?vue&type=style&index=0&id=fa79c3d2&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa79c3d2"]])

export default __exports__